"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WritingModeValue = exports.DisplayValue = exports.FilterFunction = exports.CssPropertyType = void 0;
// Copied from ambassador component-type data (CssPropertyEnumCssPropertyType).
var CssPropertyType;
(function (CssPropertyType) {
    CssPropertyType["number"] = "number";
    CssPropertyType["string"] = "string";
    CssPropertyType["angle"] = "angle";
    CssPropertyType["length"] = "length";
    CssPropertyType["percentage"] = "percentage";
    CssPropertyType["lengthPercentage"] = "lengthPercentage";
    CssPropertyType["blendMode"] = "blendMode";
    CssPropertyType["customEnum"] = "customEnum";
    CssPropertyType["time"] = "time";
    CssPropertyType["background"] = "background";
    CssPropertyType["backgroundSize"] = "backgroundSize";
    CssPropertyType["backgroundColor"] = "backgroundColor";
    CssPropertyType["backgroundImage"] = "backgroundImage";
    CssPropertyType["backgroundClip"] = "backgroundClip";
    CssPropertyType["backgroundOrigin"] = "backgroundOrigin";
    CssPropertyType["backgroundPosition"] = "backgroundPosition";
    CssPropertyType["backgroundRepeat"] = "backgroundRepeat";
    CssPropertyType["backgroundAttachment"] = "backgroundAttachment";
    CssPropertyType["margin"] = "margin";
    CssPropertyType["marginTop"] = "marginTop";
    CssPropertyType["marginRight"] = "marginRight";
    CssPropertyType["marginBottom"] = "marginBottom";
    CssPropertyType["marginLeft"] = "marginLeft";
    CssPropertyType["marginInlineStart"] = "marginInlineStart";
    CssPropertyType["marginInlineEnd"] = "marginInlineEnd";
    CssPropertyType["padding"] = "padding";
    CssPropertyType["paddingTop"] = "paddingTop";
    CssPropertyType["paddingRight"] = "paddingRight";
    CssPropertyType["paddingBottom"] = "paddingBottom";
    CssPropertyType["paddingLeft"] = "paddingLeft";
    CssPropertyType["paddingInlineStart"] = "paddingInlineStart";
    CssPropertyType["paddingInlineEnd"] = "paddingInlineEnd";
    CssPropertyType["border"] = "border";
    CssPropertyType["borderWidth"] = "borderWidth";
    CssPropertyType["borderStyle"] = "borderStyle";
    CssPropertyType["borderColor"] = "borderColor";
    CssPropertyType["borderTop"] = "borderTop";
    CssPropertyType["borderTopColor"] = "borderTopColor";
    CssPropertyType["borderTopWidth"] = "borderTopWidth";
    CssPropertyType["borderTopStyle"] = "borderTopStyle";
    CssPropertyType["borderRight"] = "borderRight";
    CssPropertyType["borderRightColor"] = "borderRightColor";
    CssPropertyType["borderRightWidth"] = "borderRightWidth";
    CssPropertyType["borderRightStyle"] = "borderRightStyle";
    CssPropertyType["borderBottom"] = "borderBottom";
    CssPropertyType["borderBottomColor"] = "borderBottomColor";
    CssPropertyType["borderBottomWidth"] = "borderBottomWidth";
    CssPropertyType["borderBottomStyle"] = "borderBottomStyle";
    CssPropertyType["borderLeft"] = "borderLeft";
    CssPropertyType["borderLeftColor"] = "borderLeftColor";
    CssPropertyType["borderLeftWidth"] = "borderLeftWidth";
    CssPropertyType["borderLeftStyle"] = "borderLeftStyle";
    CssPropertyType["borderInlineStart"] = "borderInlineStart";
    CssPropertyType["borderInlineStartColor"] = "borderInlineStartColor";
    CssPropertyType["borderInlineStartWidth"] = "borderInlineStartWidth";
    CssPropertyType["borderInlineStartStyle"] = "borderInlineStartStyle";
    CssPropertyType["borderInlineEnd"] = "borderInlineEnd";
    CssPropertyType["borderInlineEndColor"] = "borderInlineEndColor";
    CssPropertyType["borderInlineEndWidth"] = "borderInlineEndWidth";
    CssPropertyType["borderInlineEndStyle"] = "borderInlineEndStyle";
    CssPropertyType["borderRadius"] = "borderRadius";
    CssPropertyType["borderTopLeftRadius"] = "borderTopLeftRadius";
    CssPropertyType["borderTopRightRadius"] = "borderTopRightRadius";
    CssPropertyType["borderBottomRightRadius"] = "borderBottomRightRadius";
    CssPropertyType["borderBottomLeftRadius"] = "borderBottomLeftRadius";
    CssPropertyType["borderStartStartRadius"] = "borderStartStartRadius";
    CssPropertyType["borderStartEndRadius"] = "borderStartEndRadius";
    CssPropertyType["borderEndStartRadius"] = "borderEndStartRadius";
    CssPropertyType["borderEndEndRadius"] = "borderEndEndRadius";
    CssPropertyType["font"] = "font";
    CssPropertyType["fontFamily"] = "fontFamily";
    CssPropertyType["fontSize"] = "fontSize";
    CssPropertyType["fontStretch"] = "fontStretch";
    CssPropertyType["fontStyle"] = "fontStyle";
    CssPropertyType["fontVariant"] = "fontVariant";
    CssPropertyType["fontWeight"] = "fontWeight";
    CssPropertyType["lineHeight"] = "lineHeight";
    CssPropertyType["color"] = "color";
    CssPropertyType["letterSpacing"] = "letterSpacing";
    CssPropertyType["writingMode"] = "writingMode";
    CssPropertyType["textAlign"] = "textAlign";
    CssPropertyType["textTransform"] = "textTransform";
    CssPropertyType["textShadow"] = "textShadow";
    CssPropertyType["textOverflow"] = "textOverflow";
    CssPropertyType["textIndent"] = "textIndent";
    CssPropertyType["textDecoration"] = "textDecoration";
    CssPropertyType["textDecorationColor"] = "textDecorationColor";
    CssPropertyType["textDecorationLine"] = "textDecorationLine";
    CssPropertyType["textDecorationStyle"] = "textDecorationStyle";
    CssPropertyType["textDecorationThickness"] = "textDecorationThickness";
    CssPropertyType["boxShadow"] = "boxShadow";
    CssPropertyType["opacity"] = "opacity";
    CssPropertyType["overflow"] = "overflow";
    CssPropertyType["display"] = "display";
    CssPropertyType["alignSelf"] = "alignSelf";
    CssPropertyType["justifyContent"] = "justifyContent";
    CssPropertyType["alignItems"] = "alignItems";
    CssPropertyType["flexDirection"] = "flexDirection";
    CssPropertyType["height"] = "height";
    CssPropertyType["width"] = "width";
    CssPropertyType["gap"] = "gap";
    CssPropertyType["columnGap"] = "columnGap";
    CssPropertyType["rowGap"] = "rowGap";
    CssPropertyType["filter"] = "filter";
    CssPropertyType["backdropFilter"] = "backdropFilter";
    CssPropertyType["objectFit"] = "objectFit";
    CssPropertyType["objectPosition"] = "objectPosition";
    CssPropertyType["mixBlendMode"] = "mixBlendMode";
    CssPropertyType["isolation"] = "isolation";
    CssPropertyType["stroke"] = "stroke";
    CssPropertyType["strokeWidth"] = "strokeWidth";
    CssPropertyType["strokeOpacity"] = "strokeOpacity";
    CssPropertyType["fill"] = "fill";
    CssPropertyType["fillOpacity"] = "fillOpacity";
})(CssPropertyType || (exports.CssPropertyType = CssPropertyType = {}));
// ─── CSS Property Configuration Options ──────────────────────────────────────
var FilterFunction;
(function (FilterFunction) {
    FilterFunction["blur"] = "blur";
    FilterFunction["brightness"] = "brightness";
    FilterFunction["contrast"] = "contrast";
    FilterFunction["dropShadow"] = "dropShadow";
    FilterFunction["grayscale"] = "grayscale";
    FilterFunction["hueRotate"] = "hueRotate";
    FilterFunction["invert"] = "invert";
    FilterFunction["opacity"] = "opacity";
    FilterFunction["saturate"] = "saturate";
    FilterFunction["sepia"] = "sepia";
})(FilterFunction || (exports.FilterFunction = FilterFunction = {}));
var DisplayValue;
(function (DisplayValue) {
    DisplayValue["none"] = "none";
    DisplayValue["block"] = "block";
    DisplayValue["inline"] = "inline";
    DisplayValue["flow"] = "flow";
    DisplayValue["flowRoot"] = "flowRoot";
    DisplayValue["table"] = "table";
    DisplayValue["flex"] = "flex";
    DisplayValue["grid"] = "grid";
    DisplayValue["inlineBlock"] = "inlineBlock";
    DisplayValue["inlineFlex"] = "inlineFlex";
    DisplayValue["inlineGrid"] = "inlineGrid";
    DisplayValue["inlineTable"] = "inlineTable";
})(DisplayValue || (exports.DisplayValue = DisplayValue = {}));
var WritingModeValue;
(function (WritingModeValue) {
    WritingModeValue["horizontalTb"] = "horizontalTb";
    WritingModeValue["verticalRl"] = "verticalRl";
    WritingModeValue["verticalLr"] = "verticalLr";
    WritingModeValue["sidewaysRl"] = "sidewaysRl";
    WritingModeValue["sidewaysLr"] = "sidewaysLr";
})(WritingModeValue || (exports.WritingModeValue = WritingModeValue = {}));
